import React, { useState, Fragment, Component } from 'react'
import Shimmer from "react-shimmer-effect";
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle,
    Button, Table, Label
} from "reactstrap"
import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { Link, useHistory, Redirect } from "react-router-dom"
import { withRouter } from "react-router";
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import apiResponse from '../../../../services/apiResponse'
import CustomSelect from '../../../../helpers/ui/CustomSelect';

import ReportBloc from './Blocs/ReportBloc'
import moment from 'moment';

import ReportModal from './Components/ReportModal';
import ReportDetailModal from './Components/ReportDetailModal';

class IndexView extends Component {

    reportBloc = new ReportBloc()

    constructor(props) {
        super(props)
        this.state = {
          document: null,
          reportDetail: null,
          notDone: 0,
          now: moment().format('YYYY-MM-DD')
        }
    }

    toggle = () => {
        this.setState({ modal: !this.state.modal })
    }

    toggleDetail = () => {
        this.setState({ modalDetail: !this.state.modalDetail })
    }

    dateParse = (input) =>{
        let res = "-";
        if (input != "" && input != null){
          res = moment(input).format('DD/MM/YYYY')
        }
        return res;
    }

    reformatOptions = (raw, label, value) => {
        return raw.map(function(data) {
          var newObj = {};
          newObj["label"] = data[label];
          newObj["value"] = data[value];
      
          return newObj;
        });
    };

    submitData = async () => {
        await this.reportBloc.fetchReportSend(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                ...values,
                uuid: this.state.detail?.employee_wfh_uuid
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
            case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    loadDetail = () => {
        const queryParams = new URLSearchParams(this.props.location.search)
        this.reportBloc.fetchDetail({uuid: queryParams.get('uuid') })
    }

    componentDidMount() {
          this.reportBloc.reportSendChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

        this.reportBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    if(result.data.status) {
                        let response = result.data.response

                        let notDone = 0;
                        if (response.details.length > 0) {
                            response.details.map((data, index) => {
                                if (data.employee_wfh_detail_status == 0) {
                                    notDone += 1
                                }
                            })
                        }

                        this.setState({
                            detail: response,
                            document: response.document_letter,
                            notDone: notDone
                        })
                    }
                    break
                case apiResponse.ERROR:
                    
                    break
                default:
                    break
            }
        })

        this.loadDetail()
    }

    componentWillUnmount(){
      this.reportBloc.detailChannel?.unsubscribe()
      this.reportBloc.approveChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <CardTitle>Laporan WFH</CardTitle>
                                    {/* <CardSubtitle className="mb-3">
                                        Informasi Detail Pengajuan WFH
                                    </CardSubtitle> */}
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                        <label className="col-md-3">
                                            Nama Atasan
                                        </label>
                                        <Col md="9">
                                            {
                                                this.state.detail ?
                                                    <>{this.state.detail.employee_wfh_atasan !== "" ? this.state.detail.employee_wfh_atasan : '-'}</>
                                                : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                            }
                                        </Col>
                                    </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nomor Surat Keterangan WFH
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_letter_number !== "" ? this.state.detail.employee_wfh_letter_number : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                NIP
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_employee_nip !== "" ? this.state.detail.employee_wfh_employee_nip : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Nama
                                            </label>
                                            <Col md="9">
                                                {
                                                    this.state.detail ?
                                                        <>{this.state.detail.employee_wfh_employee_name !== "" ? this.state.detail.employee_wfh_employee_name : '-'}</>
                                                    : <Shimmer><div style={{width: '50%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label className="col-md-3 col-form-label">File Surat Keterangan WFH</Label>
                                            <Col md="6">
                                                {
                                                    this.state.detail ?
                                                        <>
                                                            {this.state.document !== null ?  
                                                                <a target={"_blank"} className="btn btn-sm btn-success" href={this.state.document?.documents_path}>
                                                                    Download <i className="fa fa-download ms-1"></i>
                                                                </a>
                                                            : '-'}
                                                        </>
                                                    :
                                                        <Shimmer><div style={{width: '30%', height: 15}}></div></Shimmer>
                                                }
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <label className="col-md-3">
                                                Tanggal WFH
                                            </label>
                                            <Col md="8">
                                                <div className="table-responsive">
                                                    <Table className="table-bordered table-striped">
                                                        <thead>
                                                            <tr>
                                                                <th>No</th>
                                                                <th>Tanggal</th>
                                                                <th>Status Laporan</th>
                                                                <th>Status Approval</th>
                                                                <th>Sudah Absen</th>
                                                                <th>Buat Laporan</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.detail?.details.length > 0 ? 

                                                                    this.state.detail?.details.map((data, index) => {
                                                                        return (
                                                                            <tr key={index}>
                                                                                <td>{index+=1}</td>
                                                                                <td>{this.dateParse(data.employee_wfh_detail_date)}</td>
                                                                                <td>{data.employee_wfh_detail_report_status}</td>
                                                                                <td>
                                                                                    <label className={`badge rounded-pill font-size-12 ${data.employee_wfh_detail_status_class}`}>{data.employee_wfh_detail_status_name}</label>
                                                                                </td>
                                                                                <td>
                                                                                    {data.presensi_count > 0 ? 'Ya' : 'Tidak'}
                                                                                </td>
                                                                                <td className='text-center'>
                                                                                    {
                                                                                        data.employee_wfh_detail_status == 2 ?
                                                                                            <button 
                                                                                                className="btn btn-primary btn-sm"
                                                                                                type='button' 
                                                                                                id={"report-" + data.employee_wfh_detail_id}
                                                                                                onClick={() => {
                                                                                                    this.setState({
                                                                                                        reportDetail: data,
                                                                                                    })
                                                                                                    this.toggleDetail()
                                                                                                }}
                                                                                                style={{
                                                                                                    padding: '2px 5px'
                                                                                                }}>
                                                                                                <i className="uil-align-left"></i>
                                                                                            </button>
                                                                                        :
                                                                                            data.employee_wfh_detail_date <= this.state.now && data.presensi_count > 0 ?
                                                                                            <button 
                                                                                                className="btn btn-success btn-sm"
                                                                                                type='button' 
                                                                                                id={"report-" + data.employee_wfh_detail_id}
                                                                                                onClick={() => {
                                                                                                    this.setState({
                                                                                                        reportDetail: data,
                                                                                                    })
                                                                                                    this.toggle()
                                                                                                }}
                                                                                                style={{
                                                                                                    padding: '2px 5px'
                                                                                                }}>
                                                                                                <i className="uil-edit-alt"></i>
                                                                                            </button>
                                                                                            : '-'
                                                                                    }
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })

                                                                : 
                                                                <tr>
                                                                    <td colSpan="6" className="text-center">Tidak Ada Data</td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </div>
                                            </Col>
                                        </Row>

                                        <hr />

                                        

                                        <hr />
                                        
                                        <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                {/* <Button color="success" type="submit" disabled={this.state.notDone > 0 ? true : false}> */}
                                                {/* <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Ajukan ke Atasan
                                                </Button> */}
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>

                <ReportModal
                    modal={this.state.modal} 
                    toggle={() => this.toggle()} 
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.loadDetail()} 
                    nip={this.state.detail?.employee_wfh_employee_nip} 
                    reportDetail={this.state.reportDetail} 
                />

                <ReportDetailModal
                    modal={this.state.modalDetail} 
                    toggle={() => this.toggleDetail()} 
                    // periodUuid={this.state.period?.cpns_period_uuid} 
                    // setUuid={value => this.setUuid(value)} 
                    handleReload={() => this.loadDetail()} 
                    nip={this.state.detail?.employee_wfh_employee_nip} 
                    reportDetail={this.state.reportDetail} 
                />

                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan mengajukan laporan ini?"

                    loadingTitle="Memproses Data data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/pengajuan_wfh.html?'/>
                : null }
            </Fragment>
        )
    }
}

//export default IndexView
export default withRouter(IndexView);